import { createSelector } from 'reselect';
import { filterNonGlobalConnectedAccounts } from '../operators/filterNonGlobalConnectedAccounts';
import { getAllConnectedAccounts } from './getAllConnectedAccounts';
export const getConnectedAccounts = createSelector([getAllConnectedAccounts], allConnectedAccounts => {
  return filterNonGlobalConnectedAccounts(allConnectedAccounts);
});
export default getConnectedAccounts;